export default __webpack_public_path__ + "static/404-Error-Page-04-2ba2a934d61bd76760a6b67878b07e0c.jpg";